enum FormCrudAction {
  CREATE = 'Create',
  EDIT = 'Edit',
}

export default FormCrudAction;
